module.exports = __webpack_public_path__ + "img/btn/button-secondary-hover@2x.png";


//////////////////
// WEBPACK FOOTER
// ./img/btn/button-secondary-hover@2x.png
// module id = 50
// module chunks = d-game